import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-appoint-scs",
  "use": "icon-appoint-scs-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 88\" id=\"icon-appoint-scs\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#60CE64\" cx=\"44\" cy=\"44\" r=\"44\" /><path fill=\"#FFF\" d=\"M20.827 46.614 23.46 42.8l12.687 9.963L67.66 27.262l2.866 2.838-34.379 33.406z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol